import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { Fonts } from '../../types/Constants';
import { useAuthContext } from '../authentication/contexts/AuthContext';

const Error401 = () => {
    const auth = useAuthContext();
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                height: "100vh",
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
            }}>
            <Box>
                <img src="/skidattl-logo-lightbkg.svg" width={200} alt="Skidattl Logo" />
            </Box>
            <Box sx={{ mb: 5 }}>
                <Box
                    component="h3"
                    sx={{
                        mb: 3,
                        fontSize: 24,
                        fontWeight: Fonts.MEDIUM,
                    }}>
                    Unauthorized
                </Box>
                <Box
                    sx={{
                        mb: 8,
                        color: grey[600],
                        fontSize: 16,
                        fontWeight: Fonts.MEDIUM,
                    }}>
                    <Typography>You are not authorized to view this page.</Typography>
                </Box>
                <Button
                    sx={{ ml: 2 }}
                    variant='outlined'
                    onClick={() => navigate("/")}>
                    OK
                </Button>
            </Box>
        </Box>
    );
};

export default Error401;
